// extracted by mini-css-extract-plugin
export default {"contactListLetterHeader":"ContactListItemsHeader_contactListLetterHeader__HbVKu"};